import React from 'react'
import PropTypes from 'prop-types'
import './statistics.css'
import { joinClassList } from '../utilities/utilities.js'
import { camelCase } from 'lodash'
import { getBackgroundColor } from './statsUtils.js'

export const getStatisticsParameters = (parameters) => {
  return {
    layout: camelCase(parameters.layout) || 'horizontal',
    backgroundColor: getBackgroundColor(parameters.backgroundColor),
  }
}

const Statistics = ({ children, ...props }) => {
  const {
    backgroundColor,
    layout = 'horizontal',
    desktopBackground,
    mobileBackground,
  } = props
  const isDesktop = matchMedia('(min-width: 1370px)').matches
  const imgSrc = isDesktop ? desktopBackground : mobileBackground

  const statsWrapperClasses = joinClassList([
    'Statistics',
    'u-paddingVert12gu',
    backgroundColor,
    layout === 'inset' ? 'u-sizeConstrained' : '',
    'u-posRelative',
  ])

  return (
    // TODO: how much vertical padding?
    <div className={statsWrapperClasses}>
      {imgSrc && <img src={`${imgSrc}`} alt="" />}
      <div className="u-sizeConstrained">{children}</div>
    </div>
  )
}

Statistics.propTypes = {
  backgroundColor: PropTypes.string,
  desktopBackground: PropTypes.string,
  ctaAlignment: PropTypes.oneOf(['left', 'center']),
  layout: PropTypes.oneOf(['horizontal', 'vertical', 'inset']),
}

export default Statistics
